<template>
  <div>
     
  </div>
</template>
<script>
import md5 from 'md5'
  export default {
    methods: {
      goToRulebook() {
        const userInfo = this.userInfo || {};
        if(userInfo.email){
          this.DSSAccount()
        }else{
          let hashEmail = userInfo.email ? md5(userInfo.email) : '';
          if (!hashEmail && userInfo.email) {
            hashEmail = md5(userInfo.email);
          }

          if (this.userInfo.name) {
            const hashId = userInfo['custom:emp_code'] ? md5(userInfo['custom:emp_code']) : '';
            window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          } else if (this.userInfo.name) {
            const hashId = userInfo['custom:emp_code'] ? md5(userInfo['custom:emp_code']) : '';
            window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
            this.$router.push('/');
          }
        }
      },
      DSSAccount(){
        const userInfo = this.userInfo || {};
        let hashEmail = userInfo.email ? md5(userInfo.email) : '';
        let hashId = this.formatEmpCode(userInfo['custom:emp_code']) ? md5(this.formatEmpCode(userInfo['custom:emp_code'])) : '';
        window.open(`https://documentsearch.hrd-s.com/login?index=${hashEmail}&id=${hashId}`, `_blank`)
        this.$router.push('/');
      },
      formatEmpCode(empCode) {
        if(empCode){
          const trimmedEmpCode = empCode.replace(/^0+/, '');
          return trimmedEmpCode;
        }else{
          return empCode
        }
      }
    },
    mounted() {
      this.goToRulebook()
    },
    computed: {
      userInfo() {
        return this.$root.decryptedUser;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>